(function () {
  function initBestSeller(section) {
    const slider = section.querySelector(".el-best-seller__slider");
    const progress = section.querySelector(".el-best-seller__progress");
    if (!slider || typeof Swiper === "undefined") return;

    const swiper = new Swiper(slider, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      loop: false,
      watchOverflow: true,
      pagination: progress
        ? {
            el: progress,
            type: "progressbar",
          }
        : undefined,
      breakpoints: {
        581: {
          slidesPerView: 2.5,
          spaceBetween: 12,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
      on: {
        init(instance) {
          toggleProgress(instance, progress);
        },
        resize(instance) {
          toggleProgress(instance, progress);
        },
        slidesLengthChange(instance) {
          toggleProgress(instance, progress);
        },
      },
    });

    return swiper;
  }

  function toggleProgress(swiper, progress) {
    if (!progress) return;
    const shouldShow = !swiper.isLocked;
    progress.hidden = !shouldShow;
    progress.classList.toggle("is-visible", shouldShow);
  }

  function boot(root) {
    const sections = (root || document).querySelectorAll("[data-el-best-seller]");
    sections.forEach((section) => {
      if (section.dataset.elBestSellerReady === "true") return;
      section.dataset.elBestSellerReady = "true";
      const swiper = initBestSeller(section);
      if (swiper) section._elBestSellerSwiper = swiper;
    });
  }

  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target.querySelector
      ? event.target.querySelector("[data-el-best-seller]") || event.target
      : event.target;
    if (section && section._elBestSellerSwiper) {
      section._elBestSellerSwiper.destroy(true, true);
      delete section._elBestSellerSwiper;
      delete section.dataset.elBestSellerReady;
    }
  });

  function loadSwiper(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }

    if (document.querySelector('script[data-el-swiper="true"]')) {
      const existing = document.querySelector('script[data-el-swiper="true"]');
      existing.addEventListener("load", callback, { once: true });
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.defer = true;
    script.dataset.elSwiper = "true";
    script.addEventListener("load", callback, { once: true });
    document.body.appendChild(script);
  }

  loadSwiper(() => boot());

  document.addEventListener("shopify:section:load", (event) => {
    loadSwiper(() => boot(event.target));
  });
})();
